module.exports = __webpack_public_path__ + "static/hursley-14aefc2e219980b5809371693ecec9d7.jpg";